import { useState, useEffect } from "react";

import { rpc } from "../../services/datos";
import { avisar, confirmar } from "../../shared/avisos";
import Selector from "../../shared/components/Selector";
import Esqueleto from "../../shared/components/Esqueleto";

function Notificaciones() {
  const [log, setLog] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [enviando, setEnviando] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [filtroEstado, setFiltroEstado] = useState("todos");
  const [tab, setTab] = useState("aviso");

  const cargarLog = () => {
    rpc("registro_notificaciones")
      .then((data) => setLog(data || []))
      .catch((e) => avisar(e.message || "No se pudo cargar el registro", "error"))
      .finally(() => setCargando(false));
  };

  useEffect(() => { cargarLog(); }, []);

  const enviarCumpleanos = () => {
    setEnviando(true);
    // La fecha de hoy la pone la base (hora de Colombia).
    rpc("enviar_cumpleanos")
      .then((data) => {
        setEnviando(false);
        if (data.enviados.length === 0) {
          avisar("No hay cumpleaños hoy");
        } else {
          avisar(`Se están enviando ${data.enviados.length} mensaje(s) de cumpleaños. Verás cada envío en el registro.`, "exito");
          setTimeout(cargarLog, 15000);
        }
      })
      .catch((e) => { setEnviando(false); avisar(e.message || "No se pudieron enviar los mensajes", "error"); });
  };

  const enviarAviso = async () => {
    if (!mensaje.trim()) {
      avisar("Escribe un mensaje primero");
      return;
    }
    if (!(await confirmar(`¿Enviar este mensaje a ${filtroEstado === "todos" ? "todos los miembros" : "miembros " + filtroEstado}?`, { aceptar: "Enviar", peligro: false }))) return;

    setEnviando(true);
    rpc("enviar_aviso_general", { p_mensaje: mensaje, p_estado: filtroEstado })
      .then((data) => {
        setEnviando(false);
        setMensaje("");
        cargarLog();
        // Los mensajes salen en segundo plano; cada envío aparece en el registro.
        avisar(`Enviando el mensaje a ${data.total} personas. Verás el resultado de cada envío en el registro en unos minutos.`, "exito");
        setTimeout(cargarLog, 15000);
      })
      .catch((e) => { setEnviando(false); avisar(e.message || "No se pudo enviar el mensaje", "error"); });
  };

  const colorEstado = {
    enviado: "border border-emerald-500/30 bg-emerald-500/15 text-emerald-300",
    error: "border border-rose-500/30 bg-rose-500/15 text-rose-300",
    pendiente: "border border-amber-500/30 bg-amber-500/15 text-amber-300",
  };

  const etiquetaTipo = {
    cumpleanos: "Cumpleaños",
    bienvenida: "Bienvenida",
    aviso: "Aviso",
    turno: "Turno",
  };

  return (
    <div className="p-6">

      <div className="mb-6">
        <h2 className="titulo-pagina">Notificaciones</h2>
        <p className="text-gray-400 text-sm mt-1">Envía mensajes por WhatsApp a los miembros</p>
      </div>

      {/* Tabs */}
      <div className="flex flex-wrap gap-2 mb-6">
        {[
          { id: "aviso", label: "Aviso General" },
          { id: "cumpleanos", label: "Cumpleaños" },
          { id: "log", label: "Historial" },
        ].map((t) => (
          <button
            key={t.id}
            onClick={() => setTab(t.id)}
            className={`pestana ${tab === t.id ? "pestana-activa" : ""}`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {/* Aviso General */}
      {tab === "aviso" && (
        <div className="panel p-6 max-w-2xl">
          <h3 className="titulo-panel mb-4">Enviar Aviso General</h3>

          <div className="mb-4">
            <label className="etiqueta">Enviar a</label>
            <Selector
              value={filtroEstado}
              onChange={(e) => setFiltroEstado(e.target.value)}
              className="campo"
            >
              <option value="todos">Todos los miembros</option>
              <option value="miembro">Solo miembros</option>
              <option value="congregante">Solo congregantes</option>
              <option value="visitante">Solo visitantes</option>
              <option value="servidor">Solo servidores</option>
            </Selector>
          </div>

          <div className="mb-6">
            <label className="etiqueta">Mensaje</label>
            <textarea
              value={mensaje}
              onChange={(e) => setMensaje(e.target.value)}
              rows={5}
              placeholder="Escribe el mensaje que se enviará por WhatsApp..."
              className="campo"
            />
            <p className="text-gray-500 text-xs mt-1">{mensaje.length} caracteres</p>
          </div>

          <button
            onClick={enviarAviso}
            disabled={enviando}
            className="w-full btn-primario"
          >
            {enviando ? "Enviando..." : "Enviar por WhatsApp"}
          </button>
        </div>
      )}

      {/* Cumpleaños */}
      {tab === "cumpleanos" && (
        <div className="panel p-6 max-w-2xl">
          <h3 className="titulo-panel mb-2">Felicitaciones de Cumpleaños</h3>
          <p className="text-gray-400 text-sm mb-6">
            Envía automáticamente un mensaje de cumpleaños a todos los miembros que cumplen años hoy.
          </p>

          <div className="panel-interior p-4 mb-6">
            <p className="text-gray-400 text-xs mb-1">Mensaje que se enviará:</p>
            <p className="text-white text-sm">
              🎂 ¡Feliz cumpleaños <span className="text-dorado">[Nombre]</span>! Que Dios te bendiga enormemente en este día especial. Con amor, familia Mi Casa 🏠
            </p>
          </div>

          <button
            onClick={enviarCumpleanos}
            disabled={enviando}
            className="w-full btn-primario"
          >
            {enviando ? "Enviando..." : "Enviar Felicitaciones de Hoy"}
          </button>
        </div>
      )}

      {/* Historial */}
      {tab === "log" && (
        <div className="panel p-6">
          <h3 className="titulo-panel mb-4">Historial de Notificaciones</h3>

          {cargando ? (
            <Esqueleto texto="Cargando historial…" />
          ) : log.length === 0 ? (
            <p className="text-gray-400">No hay notificaciones enviadas aún</p>
          ) : (
            <div className="space-y-3">
              {log.map((n) => (
                <div key={n.id} className="panel-interior flex items-start justify-between p-4 transition hover:border-white/30">
                  <div className="flex items-start gap-3">
                    <span className="insignia shrink-0 border-zinc-500/30 bg-zinc-500/15 text-zinc-400">{etiquetaTipo[n.tipo] || n.tipo || "Mensaje"}</span>
                    <div>
                      <p className="text-white text-sm font-semibold">
                        {n.miembros?.nombres} {n.miembros?.apellidos}
                      </p>
                      <p className="text-gray-400 text-xs mt-1">{n.mensaje}</p>
                      <p className="text-gray-600 text-xs mt-1">
                        {new Date(n.creado_en).toLocaleDateString("es-CO", {
                          day: "numeric", month: "long", year: "numeric",
                          hour: "2-digit", minute: "2-digit"
                        })}
                      </p>
                    </div>
                  </div>
                  <span className={`insignia ${colorEstado[n.estado] || "border border-zinc-500/30 bg-zinc-500/15 text-zinc-400"}`}>
                    {n.estado}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

    </div>
  );
}

export default Notificaciones;